import { render, staticRenderFns } from "./side-nav-layer-controls.vue?vue&type=template&id=6f38479e&scoped=true"
import script from "./side-nav-layer-controls.vue?vue&type=script&lang=js"
export * from "./side-nav-layer-controls.vue?vue&type=script&lang=js"
import style0 from "./side-nav-layer-controls.vue?vue&type=style&index=0&id=6f38479e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38479e",
  null
  
)

export default component.exports